"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBridges = void 0;
const cache_1 = require("@ledgerhq/live-network/cache");
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const jsHelpers_2 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const cached_1 = require("../api/cached");
const js_broadcast_1 = require("../js-broadcast");
const js_createTransaction_1 = __importDefault(require("../js-createTransaction"));
const js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
const js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
const js_preload_1 = require("../js-preload");
const js_prepareTransaction_1 = require("../js-prepareTransaction");
const js_signOperation_1 = require("../js-signOperation");
const js_synchronization_1 = require("../js-synchronization");
const serialization_1 = require("../serialization");
const utils_1 = require("../utils");
function makePrepare(getChainAPI) {
    function prepareTransaction(mainAccount, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                endpoint: (0, utils_1.endpointByCurrencyId)(mainAccount.currency.id),
            };
            const chainAPI = yield getChainAPI(config);
            return (0, js_prepareTransaction_1.prepareTransaction)(mainAccount, transaction, chainAPI);
        });
    }
    return prepareTransaction;
}
function makeSyncAndScan(getChainAPI) {
    const getAccountShape = (info) => __awaiter(this, void 0, void 0, function* () {
        const config = {
            endpoint: (0, utils_1.endpointByCurrencyId)(info.currency.id),
        };
        const chainAPI = yield getChainAPI(config);
        return (0, js_synchronization_1.getAccountShapeWithAPI)(info, chainAPI);
    });
    return {
        sync: (0, jsHelpers_1.makeSync)({ getAccountShape }),
        scan: (0, jsHelpers_1.makeScanAccounts)({ getAccountShape }),
    };
}
function makeEstimateMaxSpendable(getChainAPI) {
    function estimateMaxSpendable(arg) {
        return __awaiter(this, void 0, void 0, function* () {
            const { account, parentAccount } = arg;
            const currencyId = account.type === "Account" ? account.currency.id : parentAccount === null || parentAccount === void 0 ? void 0 : parentAccount.currency.id;
            if (currencyId === undefined) {
                throw new Error("currency not found");
            }
            const config = {
                endpoint: (0, utils_1.endpointByCurrencyId)(currencyId),
            };
            const api = yield getChainAPI(config);
            return (0, js_estimateMaxSpendable_1.default)(arg, api);
        });
    }
    const cacheKeyByAccSpendableBalance = ({ account, transaction, }) => {
        var _a;
        if (account.type === "ChildAccount") {
            throw new Error("unsupported account type");
        }
        return `${account.id}:${account.spendableBalance.toString()}:tx:${(_a = transaction === null || transaction === void 0 ? void 0 : transaction.model.kind) !== null && _a !== void 0 ? _a : "<no transaction>"}`;
    };
    return (0, cache_1.makeLRUCache)(estimateMaxSpendable, cacheKeyByAccSpendableBalance, (0, cached_1.minutes)(5));
}
function makeBroadcast(getChainAPI) {
    return (info) => __awaiter(this, void 0, void 0, function* () {
        const config = {
            endpoint: (0, utils_1.endpointByCurrencyId)(info.account.currency.id),
        };
        const api = yield getChainAPI(config);
        return (0, js_broadcast_1.broadcastWithAPI)(info, api);
    });
}
function makeSign(getChainAPI) {
    return info => {
        const config = {
            endpoint: (0, utils_1.endpointByCurrencyId)(info.account.currency.id),
        };
        const api = () => getChainAPI(config);
        return (0, js_signOperation_1.signOperationWithAPI)(info, api);
    };
}
function makePreload(getChainAPI) {
    const preload = (currency) => {
        const config = {
            endpoint: (0, utils_1.endpointByCurrencyId)(currency.id),
        };
        const api = () => getChainAPI(config);
        return (0, js_preload_1.preloadWithAPI)(currency, api);
    };
    return preload;
}
function getPreloadStrategy() {
    return {
        preloadMaxAge: js_preload_1.PRELOAD_MAX_AGE,
    };
}
function makeBridges({ getAPI, getQueuedAPI, getQueuedAndCachedAPI, }) {
    const { sync, scan } = makeSyncAndScan(getQueuedAPI);
    const accountBridge = {
        createTransaction: js_createTransaction_1.default,
        updateTransaction: jsHelpers_2.defaultUpdateTransaction,
        estimateMaxSpendable: makeEstimateMaxSpendable(getQueuedAndCachedAPI),
        getTransactionStatus: js_getTransactionStatus_1.default,
        sync,
        receive: (0, jsHelpers_1.makeAccountBridgeReceive)(),
        prepareTransaction: makePrepare(getQueuedAndCachedAPI),
        broadcast: makeBroadcast(getAPI),
        signOperation: makeSign(getAPI),
        assignFromAccountRaw: serialization_1.assignFromAccountRaw,
        assignToAccountRaw: serialization_1.assignToAccountRaw,
    };
    const currencyBridge = {
        preload: makePreload(getQueuedAndCachedAPI),
        hydrate: js_preload_1.hydrate,
        scanAccounts: scan,
        getPreloadStrategy,
    };
    return {
        currencyBridge,
        accountBridge,
    };
}
exports.makeBridges = makeBridges;
//# sourceMappingURL=bridge.js.map